/**
 * The Stripe SDK will fail to load if the amount is zero, on both web and native.
 * This makes it so that we'll use a fake amount of $1 if the order total is zero.
 * It doesn't impact ordering since in that case we submit the order with "NO_PAYMENT_METHOD_NEEDED" as the payment method.
 * If the customer changes the total so that it is no longer zero, it will update the total in the SDK.
 */
export const getMinimumAmount = (amount: number) => {
  return amount <= 0 ? 100 : amount;
};
